import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

export const DistributionOfLandedCostsDetailProducts = () => {
  const tableName = "products";
  const { t } = useTranslation();

  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFLookupProduct fieldName={"productId"} title={t("Product")} />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit")} />
        <NFIntInput fieldName={"quantity"} title={t("Quantity")} width={100} />
        <NFIntInput fieldName={"weight"} title={t("Weight")} width={100} />
        <NFTextInput fieldName={"loadingPerVehicle"} title={t("LoadingPerVehicle")} />
        <NFIntInput fieldName={"amount"} title={t("Amount")} width={100} />
        <NFIntInput fieldName={"expenseAmount"} title={t("ExpenseAmount")} width={100} />
        <NFLookupAccount fieldName={"accountId"} title={t("Account")} />
      </NFormTable>
    </>
  );
};
